import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { getSubscriptionVariantPlanPeriods } from "./getSubscriptionVariantPlans.js";
import { getSubscriptionType } from "./getSubscriptionType.js";
import { isSubscriptionShapeBookClub, isSubscriptionShapeDigitalService, isSubscriptionShapeSeries, isSubscriptionShapeSubscription, } from "../../subscription-plan/selectors/isSubscriptionShape.js";
export const getSubscriptionDefaultPeriod = (subscription) => {
    const defaultPeriod = getComponentContentById(subscription.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.VARIANT.DEFAULT_PERIOD);
    if (defaultPeriod?.__typename !== "SelectionContent" ||
        !defaultPeriod?.options?.[0]?.value) {
        throw new Error(`Subscription has not set default period - Product sku ${subscription.sku}`);
    }
    return parseSubscriptionPeriod(defaultPeriod.options[0].value);
};
/**
 * Parses a subscription period string into an object with value and unit.
 * @param periodStr A string with the possible values 1-week, 2-week, 4-week and 6-week
 * @returns An object with value and unit, for example { value: 1, unit: "week" }
 */
const parseSubscriptionPeriod = (periodStr) => {
    const [periodValue, periodUnit] = periodStr.split("-");
    if (!periodValue || !periodUnit) {
        throw new Error(`Invalid period format: ${periodStr}`);
    }
    return {
        value: parseInt(periodValue, 10),
        unit: periodUnit,
    };
};
export const getDefaultPlanPeriod = (subscription) => {
    const planPeriods = getSubscriptionVariantPlanPeriods(subscription);
    const subscriptionType = getSubscriptionType(subscription);
    const isSeries = isSubscriptionShapeSeries(subscriptionType);
    const isBookSubscription = isSubscriptionShapeSubscription(subscriptionType);
    const isBookClub = isSubscriptionShapeBookClub(subscriptionType);
    const isDigitalService = isSubscriptionShapeDigitalService(subscriptionType);
    if (isBookSubscription || isBookClub || isDigitalService) {
        return planPeriods[0];
    }
    if (!isSeries)
        throw new Error(`Unsupported subscription shape for default plan period - Sku ${subscription?.sku}`);
    const defaultPeriod = getSubscriptionDefaultPeriod(subscription);
    const defaultPlan = planPeriods.find((p) => p.recurring?.unit === defaultPeriod.unit &&
        p.recurring?.period.toString() === defaultPeriod.value.toString());
    if (!defaultPlan) {
        throw new Error(`No matching plan found for default period: ${defaultPeriod.value}-${defaultPeriod.unit}`);
    }
    return defaultPlan;
};
